module.exports = __webpack_public_path__ + "img/silverShadow.ac3d96eb.webp";